import { config } from "../config";
import { networkLayer } from "./networkLayer";

const basePath = "dashboard/study-settings";

export type StudySettingsFileType = "modules" | "analysis-settings";

export interface StudySettingsFileState {
  exists: boolean;
  key?: string;
  content_type?: string;
}

export type StudySettingsFilesState = Record<StudySettingsFileType, StudySettingsFileState>;

export interface StudySettingsUploadResponse {
  data: {
    file_type: StudySettingsFileType;
    files: StudySettingsFilesState;
  };
  error: unknown | null;
  message: string;
}

const readFile = async (studyId: string, entityPath: string): Promise<Blob | null> => {
  const response = await networkLayer(
    "get",
    `${config.dataUrls}/${basePath}/${entityPath}/read-link/`,
    null,
    { study_id: studyId },
    "blob"
  );

  if (response instanceof Blob && response.size > 0) {
    return response;
  }

  return null;
};

const uploadFile = async (
  studyId: string,
  entityPath: string,
  file: Blob,
  fileName: string
): Promise<StudySettingsUploadResponse> => {
  const formData = new FormData();

  formData.append("study_id", studyId);
  formData.append("file", file, fileName);

  return await networkLayer(
    "post",
    `${config.dataUrls}/${basePath}/${entityPath}/upload/`,
    formData
  );
};

export const readModulesFile = async (studyId: string) => readFile(studyId, "modules");

export const uploadModulesFile = async (studyId: string, file: Blob, fileName: string) =>
  uploadFile(studyId, "modules", file, fileName);

export const readAnalysisSettingsFile = async (studyId: string) =>
  readFile(studyId, "analysis-settings");

export const uploadAnalysisSettingsFile = async (studyId: string, file: Blob, fileName: string) =>
  uploadFile(studyId, "analysis-settings", file, fileName);
